export const subscriptionModalClassName = 'subscription-modal' as const;

export enum SUBSCRIPTION_STEPS {
    NETWORK_ERROR,
    PLAN_SELECTION,
    CHECKOUT,
    UPGRADE,
    THANKS,
}
